import React from "react";
import { connect } from "react-redux";
import axios from "axios";
import { HOST_URL } from "../../helpers/constants/Constants";
import TrainingPageSummary from "../PageApps/TrainingPageSummary";
import Div100vh from "react-div-100vh/lib/Div100vh";
import TopNavbar from "../topNavbar/TopNavbar";
import PageHeader from "../../pages/pageHeader/PageHeader";
import store from "../../helpers/store/Store";
import { updateTrainingContent } from "../../helpers/actions/Action";
import { NavLink } from "react-router-dom";
import { object } from "yup";
import { Prompt } from "react-router";

axios.defaults.withCredentials = true;
class TrainingPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      role: "",
      selectedRole: "",
      roles: [],
      trainings: "",
      modalTrainings: {},
      defaultTrainings: {},
      completedTrainings: {},
      showModal: false,
      isAuthorised: false,
      trainingContent: "",
      isSavedData: false,
      filteredAdditCourses: [],
    };
  }

  componentDidMount() {
    // console.log("component Mounted");
    let userProfile;
    let latestTrainingContent;

    const userData = {
      userId: this.props.user.id,
      userName: this.props.user.name,
    };

    const formData = new FormData();

    formData.append("formData", JSON.stringify(userData));

    axios({
      method: "post",
      url: HOST_URL + `/api/training/getuserrecord`,
      data: formData,
    })
      .then((response) => {
        if (!response.data.trainingRecord) {
          // console.log("--------- NO USER DATA ----------");
          this.setState({ isSavedData: false });
        } else {
          // console.log("--------- USER DATA ----------");
          userProfile = response.data.trainingRecord;
          this.setState({
            trainings: response.data.trainingRecord,
            filteredAdditCourses:
              response.data.trainingRecord.notRequiredTraining,
            selectedRole: response.data.role,
            isSavedData: true,
          });
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        axios({
          method: "get",
          url: HOST_URL + `/api/training/gettrainingcontent`,
          headers: {
            "Content-Type": "application/json",
          },
        })
          .then((response) => {
            latestTrainingContent = response.data.trainingContent;
            this.setState({
              roles: response.data.roles.sort((a, b) =>
                a.displayName
                  .toLowerCase()
                  .localeCompare(b.displayName.toLowerCase())
              ),
              trainingContent: response.data.trainingContent,
            });
            //add in a reducer here to store trainingContent to the store.
            store.dispatch(
              updateTrainingContent(response.data.trainingContent)
            );
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            this.handleTrainingMerge(
              this.state.selectedRole,
              userProfile,
              latestTrainingContent
            );
          });
      });
  }

  handleTrainingMerge = (role, userTraining, defaultTraining) => {
    if (userTraining) {
      var tempUserTraining = [
        ...userTraining.mandatoryTraining,
        ...userTraining.recomendedTraining,
        ...userTraining.availableTraining,
        ...userTraining.notRequiredTraining,
      ];

      var userCompletedTraining = tempUserTraining.filter((data) => {
        return data.trainingData.completed === "true";
      });
    }

    let mergedTrainingContent = [];
    let toBreak = false;

    if (userTraining) {
      for (let i = 0; i < defaultTraining.length; i++) {
        for (let j = 0; j < userCompletedTraining.length; j++) {
          if (userCompletedTraining[j].id === defaultTraining[i].id) {
            mergedTrainingContent.push(userCompletedTraining[j]);
            toBreak = true;
            break;
          }
        }
        if (toBreak === true) {
          toBreak = false;
          continue;
        }

        mergedTrainingContent.push(defaultTraining[i]);
      }
    } else {
      mergedTrainingContent = [...defaultTraining];
    }

    this.trainingFilter(role, mergedTrainingContent);
  };

  handleCurrentCheckboxChange = (elem) => {
    var splitId = elem.target.id.split("*");
    var tempTrainings = { ...this.state.trainings };

    for (let i = 0; i < tempTrainings[splitId[2]].length; i++) {
      if (tempTrainings[splitId[2]][i].trainingTitle === splitId[3]) {
        tempTrainings[splitId[2]][i].trainingData.completed =
          elem.target.checked.toString();
      }
    }
    this.setState({
      trainings: tempTrainings,
    });
    this.quickSave(this.state.selectedRole, tempTrainings);
  };

  quickSave = (role, trainings) => {
    const tempData = {
      userId: this.props.user.id,
      userName: this.props.user.name,
      role: role,
      trainingRecord: trainings,
    };
    const formData = new FormData();
    formData.append("FormData", JSON.stringify(tempData));
    axios({
      method: "post",
      url: HOST_URL + `/api/training/saveuserrecord`,
      data: formData,
    })
      .then((response) => {
        // this.setState({ isSavedData: true });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleSaveClick = () => {
    const tempData = {
      userId: this.props.user.id,
      userName: this.props.user.name,
      role: this.state.selectedRole,
      trainingRecord: this.state.trainings,
    };
    const formData = new FormData();
    formData.append("FormData", JSON.stringify(tempData));
    axios({
      method: "post",
      url: HOST_URL + `/api/training/saveuserrecord`,
      data: formData,
    })
      .then((response) => {
        alert("Data saved successfully");
        this.setState({ isSavedData: true });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleNewCheckboxChange = (elem) => {
    var tempTrainings = { ...this.state.trainings };
    var splitId = elem.target.id.split("*");
    var selectedCourse = {};

    for (let i = 0; i < tempTrainings[splitId[2]].length; i++) {
      if (tempTrainings[splitId[2]][i].trainingTitle === splitId[3]) {
        selectedCourse = { ...tempTrainings[splitId[2]][i] };
        tempTrainings[splitId[2]][i].trainingData.added =
          elem.target.checked.toString();

        //this is changing all the role data of the selected training that shows X to make it A.
        Object.keys(tempTrainings[splitId[2]][i].roleData).forEach((key) =>
          tempTrainings[splitId[2]][i].roleData[key] === "X"
            ? (tempTrainings[splitId[2]][i].roleData[key] = "A")
            : tempTrainings[splitId[2]][i].roleData[key]
        );
      }
    }

    this.setState({
      trainings: tempTrainings,
    });

    var filteredCourses = this.state.trainings["availableTraining"].filter(
      (item) => {
        return item.trainingTitle === splitId[3];
      }
    );

    // var tempUserTrainings = { ...this.state.trainings };

    if (filteredCourses.length === 0 && elem.target.checked) {
      tempTrainings["availableTraining"].push(selectedCourse);
      this.setState({
        trainings: tempTrainings,
      });
    } else if (filteredCourses.length !== 0 && !elem.target.checked) {
      var index = -1;
      tempTrainings["availableTraining"].forEach((item, id) => {
        if (item.trainingTitle === splitId[3]) {
          index = id;
        }
      });
      tempTrainings["availableTraining"].splice(index, 1);
      this.setState({
        trainings: tempTrainings,
      });
    }
    this.handleSaveClick();
  };

  handleDropdownChange = (elem) => {
    this.handleTrainingMerge(
      elem.target.value,
      this.state.trainings,
      this.state.trainingContent
    );
    this.setState({
      selectedRole: elem.target.value,
      isSavedData: true,
    });
  };

  trainingFilter = (role, training) => {
    var mandatoryTraining = training.filter((data) => {
      return data.roleData[role] === "M";
    });
    var recomendedTraining = training.filter((data) => {
      return data.roleData[role] === "R";
    });
    var availableTraining = training.filter((data) => {
      return data.roleData[role] === "A";
    });
    var notRequiredTraining = training.filter((data) => {
      return data.roleData[role] === "X";
    });

    this.setState({
      trainings: {
        mandatoryTraining: mandatoryTraining.sort((a, b) =>
          a.trainingTitle
            .toLowerCase()
            .localeCompare(b.trainingTitle.toLowerCase())
        ),
        recomendedTraining: recomendedTraining.sort((a, b) =>
          a.trainingTitle
            .toLowerCase()
            .localeCompare(b.trainingTitle.toLowerCase())
        ),
        availableTraining: availableTraining.sort((a, b) =>
          a.trainingTitle
            .toLowerCase()
            .localeCompare(b.trainingTitle.toLowerCase())
        ),
        notRequiredTraining: notRequiredTraining.sort((a, b) =>
          a.trainingTitle
            .toLowerCase()
            .localeCompare(b.trainingTitle.toLowerCase())
        ),
      },
      filteredAdditCourses: notRequiredTraining,
    });
    this.quickSave(role, {
      mandatoryTraining,
      recomendedTraining,
      availableTraining,
      notRequiredTraining,
    });
  };

  filterAdditionalCourses = (e) => {
    const value = e.target.value;
    const filteredAdditionalCourses =
      this.state.trainings.notRequiredTraining.filter((post) =>
        post.trainingTitle.toLowerCase().includes(value)
      );

    this.setState({
      filteredAdditCourses: filteredAdditionalCourses,
    });
  };

  // linkToPPTFile =
  //   "https://scholar.harvard.edu/files/torman_personal/files/samplepptx.pptx";

  render() {
    return (
      <div style={{ overflowY: "auto" }}>
        <Div100vh>
          <Prompt
            when={true}
            message="You are about to navigate away from this page, please make sure you have saved before proceeding."
          />
          <TopNavbar />
          <PageHeader src="/water-bg.jpeg" alt="water-bg"></PageHeader>
          <TrainingPageSummary name={this.props.user.name} />
          <br />
          {this.props.user.length !== 0 ? (
            <div
              style={{
                textAlign: "center",
                marginTop: "25px",
                marginBottom: "25px",
              }}
            >
              <div
                style={{
                  textAlign: "center",
                  marginTop: "25px",
                  marginBottom: "25px",
                }}
              >
                <select
                  onChange={this.handleDropdownChange}
                  value={this.state.selectedRole}
                >
                  <option key="default" value="">
                    Please select your role
                  </option>

                  {this.state.roles.map((item, index) => {
                    return (
                      <option key={index} value={item.roleName}>
                        {item.displayName}
                      </option>
                    );
                  })}
                </select>
              </div>
              {/* // ) : null} */}
              {this.state.isSavedData ? (
                <div
                  style={{
                    textAlign: "center",
                    marginTop: "25px",
                    marginBottom: "25px",
                  }}
                >
                  <button
                    type="button"
                    id="show-modal-button"
                    className="btn btn-primary"
                    style={{ marginLeft: "10px" }}
                    data-toggle="modal"
                    data-target="#standardModal"
                    onClick={() =>
                      this.setState({
                        showModal: true,
                      })
                    }
                  >
                    Add Extra Courses
                  </button>
                  {this.state.isSavedData ? (
                    <button
                      type="button"
                      className="btn btn-primary"
                      style={{ marginLeft: "15px" }}
                      onClick={this.handleSaveClick}
                    >
                      Save
                    </button>
                  ) : (
                    <></>
                  )}
                </div>
              ) : null}
              {/* <br /> */}

              <div
                className="modal fade"
                id="standardModal"
                role="dialog"
                aria-labelledby="standardModalLabel"
                data-animation="false"
              >
                <div className="modal-dialog modal-lg" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        data-keyboard="true"
                        aria-label="Close"
                        onClick={() =>
                          this.setState({
                            showModal: false,
                          })
                        }
                      >
                        <span>Close</span>
                      </button>
                      <h4
                        className="modal-title"
                        id="standardModalLabel"
                        style={{
                          fontWeight: "bold",
                          fontSize: "20px",
                          color: "grey",
                        }}
                      >
                        Additional Courses
                      </h4>
                    </div>
                    <div className="modal-body" style={{ overflowY: "auto" }}>
                      <div className="dialog">
                        {this.state.showModal ? (
                          <div className="dialog-body">
                            <h4>Additional Courses</h4>
                            <br />
                            <div className=" row justify-content-center">
                              <input
                                className="form-control form-control-sm"
                                type="search"
                                placeholder="Search Additional Courses"
                                aria-label="Search"
                                style={{ margin: 0 }}
                                onChange={(e) =>
                                  this.filterAdditionalCourses(e)
                                }
                              />
                            </div>
                            <br />
                            <table className="table table-responsive">
                              <thead>
                                <tr id={"new*row*notRequiredTraining"}>
                                  <th>Title</th>
                                  {/* <th>Link</th> */}
                                  <th>Format</th>
                                  <th>Select</th>
                                </tr>
                              </thead>
                              <tbody>
                                {Object.keys(
                                  this.state.trainings.notRequiredTraining
                                ).length !== 0
                                  ? this.state.filteredAdditCourses.map(
                                      (item) => {
                                        return (
                                          <tr
                                            id={
                                              "new*row*notRequiredTraining*" +
                                              item.trainingTitle
                                            }
                                            key={item.id}
                                          >
                                            <td>{item.trainingTitle}</td>
                                            {/* <td>
                                            <a
                                              className="nav-link"
                                              href={item.trainingData.url}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                            >
                                              Click here to go to the training
                                            </a>
                                          </td> */}
                                            <td>{item.trainingData.format}</td>
                                            <td>
                                              {
                                                <input
                                                  type="checkbox"
                                                  id={
                                                    "new*checkbox*notRequiredTraining*" +
                                                    item.trainingTitle
                                                  }
                                                  defaultChecked={
                                                    item.trainingData.added ===
                                                    "true"
                                                  }
                                                  onChange={
                                                    this.handleNewCheckboxChange
                                                  }
                                                  // disabled={
                                                  //   this.state.trainings.mandatoryTraining.filter(
                                                  //     (elem) => {
                                                  //       return (
                                                  //         elem.trainingTitle ===
                                                  //         item.trainingTitle
                                                  //       );
                                                  //     }
                                                  //   ).length !== 0
                                                  // }
                                                />
                                              }
                                            </td>
                                          </tr>
                                        );
                                      }
                                    )
                                  : null}
                              </tbody>
                            </table>
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        data-dismiss="modal"
                        onClick={() =>
                          this.setState({
                            showModal: false,
                          })
                        }
                      >
                        Ok
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <h3
                style={{
                  marginTop: "25px",
                  fontWeight: "bold",
                  fontSize: "30px",
                }}
              >
                My Courses
              </h3>
              {/* <iframe
                src={`https://view.officeapps.live.com/op/embed.aspx?src=${this.linkToPPTFile}`}
                width="100%"
                height="80%"
                frameBorder="0"
                title="slides"
              ></iframe> */}
              {/* <iframe
                src="https://onedrive.live.com/embed?resid=1892338432C47C25%2194301&amp;authkey=%21AGhQ8lZai_zlY3Q&amp;em=2&amp;wdAr=1.7777777777777777"
                width="476px"
                height="288px"
                frameborder="0"
              ></iframe> */}
              <h4
                style={{ fontWeight: "bold", fontSize: "20px", color: "grey" }}
              >
                Mandatory
              </h4>
              <table
                className="table table-responsive"
                style={{ width: "75%", display: "inline-table" }}
              >
                <thead>
                  <tr id={"current*row*mandatoryTraining"}>
                    <th>Title</th>
                    <th>Link</th>
                    <th>Format</th>
                    <th>Est Time to Complete</th>
                    <th>Completed</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(this.state.trainings).length !== 0
                    ? this.state.trainings.mandatoryTraining.map((item) => {
                        const newPath = "/training/" + item.trainingData.tag;
                        return (
                          <tr
                            id={
                              "current*row*mandatoryTraining*" +
                              item.trainingTitle
                            }
                            key={item.id}
                          >
                            <td>{item.trainingTitle}</td>
                            <td>
                              {item.trainingData.format === "Other" ? (
                                <a
                                  className="nav-link"
                                  href={item.trainingData.url}
                                  // href="/DSEARToolboxTalk"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  Click here to go to the training
                                </a>
                              ) : (
                                <NavLink
                                  className="nav-link"
                                  activeClassName="active"
                                  to={newPath}
                                >
                                  <span className="d-lg-inline-block">
                                    Click here to go to the training
                                  </span>
                                </NavLink>
                              )}
                            </td>
                            <td>{item.trainingData.format}</td>
                            <td>{item.trainingData.time}</td>
                            <td>
                              {
                                <input
                                  type="checkbox"
                                  id={
                                    "current*checkbox*mandatoryTraining*" +
                                    item.trainingTitle
                                  }
                                  defaultChecked={
                                    item.trainingData.completed === "true"
                                  }
                                  onChange={this.handleCurrentCheckboxChange}
                                />
                              }
                            </td>
                          </tr>
                        );
                      })
                    : null}
                </tbody>
              </table>
              <h4
                style={{ fontWeight: "bold", fontSize: "20px", color: "grey" }}
              >
                Recommended
              </h4>
              <table
                className="table table-responsive"
                style={{ width: "75%", display: "inline-table" }}
              >
                <thead>
                  <tr id={"current*row*recomendedTraining"}>
                    <th>Title</th>
                    <th>Link</th>
                    <th>Format</th>
                    <th>Est Time to Complete</th>
                    <th>Completed</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(this.state.trainings).length !== 0
                    ? this.state.trainings.recomendedTraining.map((item) => {
                        const newPath = "/training/" + item.trainingData.tag;
                        return (
                          <tr
                            id={
                              "current*row*recomendedTraining*" +
                              item.trainingTitle
                            }
                            key={item.id}
                          >
                            <td>{item.trainingTitle}</td>
                            <td>
                              {item.trainingData.format === "Other" ? (
                                <a
                                  className="nav-link"
                                  href={item.trainingData.url}
                                  // href="/DSEARToolboxTalk"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  Click here to go to the training
                                </a>
                              ) : (
                                <NavLink
                                  className="nav-link"
                                  activeClassName="active"
                                  to={newPath}
                                  onClick={this.quickSave}
                                >
                                  <span className="d-lg-inline-block">
                                    Click here to go to the training
                                  </span>
                                </NavLink>
                              )}
                            </td>
                            <td>{item.trainingData.format}</td>
                            <td>{item.trainingData.time}</td>
                            <td>
                              {
                                <input
                                  type="checkbox"
                                  id={
                                    "current*checkbox*recomendedTraining*" +
                                    item.trainingTitle
                                  }
                                  defaultChecked={
                                    item.trainingData.completed === "true"
                                  }
                                  onChange={this.handleCurrentCheckboxChange}
                                />
                              }
                            </td>
                          </tr>
                        );
                      })
                    : null}
                </tbody>
              </table>
              <h4
                style={{ fontWeight: "bold", fontSize: "20px", color: "grey" }}
              >
                Available
              </h4>
              <table
                className="table table-responsive"
                style={{ width: "75%", display: "inline-table" }}
              >
                <thead>
                  <tr id={"current*row*availableTraining"}>
                    <th>Title</th>
                    <th>Link</th>
                    <th>Format</th>
                    <th>Est Time to Complete</th>
                    <th>Completed</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(this.state.trainings).length !== 0
                    ? this.state.trainings.availableTraining.map((item) => {
                        const newPath = "/training/" + item.trainingData.tag;
                        return (
                          <tr
                            id={
                              "current*row*availableTraining*" +
                              item.trainingTitle
                            }
                            key={item.id}
                          >
                            <td>{item.trainingTitle}</td>
                            <td>
                              {item.trainingData.format === "Other" ? (
                                <a
                                  className="nav-link"
                                  href={item.trainingData.url}
                                  // href="/DSEARToolboxTalk"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  Click here to go to the training
                                </a>
                              ) : (
                                <NavLink
                                  className="nav-link"
                                  activeClassName="active"
                                  to={newPath}
                                >
                                  <span className="d-lg-inline-block">
                                    Click here to go to the training
                                  </span>
                                </NavLink>
                              )}
                            </td>
                            <td>{item.trainingData.format}</td>
                            <td>{item.trainingData.time}</td>
                            <td>
                              {
                                <input
                                  type="checkbox"
                                  id={
                                    "current*checkbox*availableTraining*" +
                                    item.trainingTitle
                                  }
                                  defaultChecked={
                                    item.trainingData.completed === "true"
                                  }
                                  onChange={this.handleCurrentCheckboxChange}
                                />
                              }
                            </td>
                          </tr>
                        );
                      })
                    : null}
                </tbody>
              </table>
            </div>
          ) : (
            <>
              <br />
              <div style={{ textAlign: "center" }}>
                <h1 style={{ fontWeight: "bold" }}>
                  Please login <a href="/">HERE</a> to access the training page.
                </h1>
              </div>
            </>
          )}
        </Div100vh>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.requestUserDataReducer.data,
  reduxTrainingContent: state.trainingContentReducer,
  user: state.requestUserDataReducer.data,
});

export default connect(mapStateToProps)(TrainingPage);
